<template>
    <div>
        <multiselect class="form-control" v-model="modelo.iduniversidad" :options="datos" track-by="id" label="nombre" 
        :searchable="true" :loading="isLoading" :close-on-select="true" :show-labels="false" placeholder="Seleccione..."></multiselect>
    </div>
</template>

<script> 
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ model:Object,convenio:{type:Boolean,required:false,default:false},default:{type:Object,required:false,default:null},xdefault:{type:Number,required:false} },
    data(){
        return{
            datos: [],
            isLoading: true,
            modelo: {
                iduniversidad: null,
            }
        }
    },
    watch:{
        'modelo.iduniversidad': function(){this.model.iduniversidad=this.modelo.iduniversidad; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.iduniversidad = a;
        },
        'xdefault': function(){
            if( this.xdefault ){
                let uni = this.datos.find( x => x.id == this.xdefault );
                if( uni ) this.modelo.iduniversidad = uni;
            }
        }
    },
    methods:{
         async getDatos() {
            var vue = this;
            var sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var unis = [];
                var datas = [];
                if( this.convenio ){
                    datas = data.data.getInstituciones.filter(function(e){ return e.convenio })
                }else{
                    datas = data.data.getInstituciones;
                }
                datas.forEach( function(e){
                    if( !e.nombre.includes('Ninguno') )
                        unis.push( {id:e.id,nombre:e.abreviatura+' - '+e.nombre,tipo:e.tipo,convenio:e.convenio,abreviatura:e.abreviatura} )
                });

                this.datos = unis;                
                this.isLoading = false;

                if( this.xdefault ){
                    let uni = this.datos.find( x => x.id == this.xdefault );
                    if( uni ) this.modelo.iduniversidad = uni;
                }
            }).catch((error) => {
                window.console.error(error)
                vue.$notify( parseJsonError( error,'getInstituciones' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>